export enum QuickFilter {
  Active,
  Inactive,
  LastSevenDays,
  Global,
  Manual,
  Automated,
  MyItems,
}
